import React, { useEffect, useState } from "react";
import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { getPaymentTxById } from "../../api/paymentTx";
import { formatCurrency } from "../../services/valueFormatters";

export default function PaymentTxAllocationsView({ props }) {
  const { id } = props;
  const [allocations, setAllocations] = useState([]);

  useEffect(() => {
    getPaymentTxById(id).then((response) => setAllocations(response.data.allocations || []));
  }, [id]);

  return (
    <Box p={1} minWidth={600}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Recibo / Cuota</TableCell>
            <TableCell align="right">Monto Aplicado</TableCell>
            <TableCell>Razón de Variación</TableCell>
            <TableCell align="right">Saldo Anterior</TableCell>
            <TableCell align="right">Saldo Insoluto</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allocations.map((allocation) => (
            <TableRow key={allocation.id}>
              <TableCell>
                {allocation.raPayment
                  ? `Recibo #${allocation.raPayment.receiptAcknowledgementId} — Cuota ${allocation.raPayment.installmentNo}`
                  : `Cuota #${allocation.raPaymentId}`}
              </TableCell>
              <TableCell align="right">{formatCurrency(allocation.amountApplied)}</TableCell>
              <TableCell>{allocation.varianceReason?.name || "—"}</TableCell>
              <TableCell align="right">
                {allocation.previousBalance != null ? formatCurrency(allocation.previousBalance) : "—"}
              </TableCell>
              <TableCell align="right">
                {allocation.remainingBalance != null ? formatCurrency(allocation.remainingBalance) : "—"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
